import './globals.css'
import '@fontsource-variable/inter'

import { MotionConfig } from 'motion/react'
import { NuqsAdapter } from 'nuqs/adapters/react'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'

import { Provider } from '@/components/ui/provider'
import { useIsMobile } from '@/hooks/use-mobile'
import { SWRConfigProvider } from '@/providers/SWRConfigProvider'

import i18n from './i18n'
import { router } from './router'

export default function App() {
  // na telefonu nahoře, aby toast nezakrýval platební tlačítka a spodní lišty
  const isMobile = useIsMobile()
  return (
    <I18nextProvider i18n={i18n} defaultNS="translation">
      <SWRConfigProvider>
        <NuqsAdapter>
          <Provider defaultTheme="light" storageKey="theme">
            {/* Animované ikony respektují systémové omezení pohybu */}
            <MotionConfig reducedMotion="user">
              <RouterProvider router={router} />
            </MotionConfig>
            <Toaster richColors closeButton position={isMobile ? 'top-center' : 'bottom-right'} />
          </Provider>
        </NuqsAdapter>
      </SWRConfigProvider>
    </I18nextProvider>
  )
}
